import { useSelector } from 'react-redux';
import { selectStreet, selectCity, selectPostalCode, selectInvoiceStreet, selectInvoiceCity, selectInvoicePostalCode } from '@store/order/selectors';



const CustomerAddress = (): JSX.Element => {

	const invoiceStreet = useSelector(selectInvoiceStreet);
	const invoiceCity = useSelector(selectInvoiceCity);
	const invoicePostalCode = useSelector(selectInvoicePostalCode);

	const street = useSelector(selectStreet);
	const city = useSelector(selectCity);
	const postalCode = useSelector(selectPostalCode);

	const existDeliveryAddress = street && city && postalCode ? true : false;

	return (
		<>
			<div className='order-summary-element'>

				<h2>Adresa</h2>

				<div className='summary-grid'>

					<p>Ulice a číslo:</p>
					<p>{invoiceStreet ? invoiceStreet : '-'}</p>

					<p>Město:</p>
					<p>{invoiceCity ? invoiceCity : '-'}</p>

					<p>PSČ:</p>
					<p>{invoicePostalCode ? invoicePostalCode : '-'}</p>

				</div>

			</div>

			{existDeliveryAddress &&
				<div className='order-summary-element'>

					<h2>Doručovací adresa</h2>

					<div className='summary-grid'>

						<p>Ulice a číslo:</p>
						<p>{street ? street : '-'}</p>

						<p>Město:</p>
						<p>{city ? city : '-'}</p>

						<p>PSČ:</p>
						<p>{postalCode ? postalCode : '-'}</p>

					</div>

				</div>}
		</>
	);
};

export default CustomerAddress;